var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85357 7.35355C9.04883 7.15829 9.04883 6.84171 8.85357 6.64645L6.20712 4L8.85357 1.35355C9.04883 1.15829 9.04883 0.841709 8.85357 0.646447C8.65831 0.451184 8.34172 0.451184 8.14646 0.646447L4.79291 4L8.14646 7.35355C8.34172 7.54882 8.65831 7.54882 8.85357 7.35355Z",
    fill: "#1D1D46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7284 17.1944C10.3248 18.1525 8.63744 18.6055 6.94271 18.4793C5.24797 18.353 3.64637 17.6549 2.40027 16.4993C1.15417 15.3438 0.337464 13.7993 0.0839396 12.1189C-0.169585 10.4384 0.155106 8.72174 1.00482 7.24999C1.14289 7.01085 1.44869 6.92891 1.68783 7.06698C1.92698 7.20505 2.00892 7.51085 1.87085 7.74999C1.13443 9.02551 0.853027 10.5133 1.07275 11.9697C1.29247 13.426 2.00029 14.7646 3.08024 15.7661C4.16019 16.7676 5.54825 17.3726 7.01702 17.482C8.48578 17.5915 9.94818 17.1988 11.1646 16.3685C12.3811 15.5381 13.2795 14.3192 13.7126 12.9115C14.1457 11.5038 14.0879 9.99072 13.5487 8.62014C13.0094 7.24957 12.0207 6.10277 10.7444 5.36761C9.75275 4.79637 8.63315 4.49998 7.50001 4.49998L5.50002 4.49999L5.42493 3.50566C5.65124 3.47129 6.11443 3.47381 6.50786 3.48013C6.7113 3.48341 6.9058 3.48802 7.07251 3.49198C7.2582 3.49639 7.40939 3.49998 7.50001 3.49998C8.80746 3.49998 10.0993 3.84196 11.2436 4.50109C12.7162 5.34935 13.857 6.67258 14.4792 8.25401C15.1015 9.83544 15.1681 11.5813 14.6684 13.2056C14.1686 14.8299 13.132 16.2363 11.7284 17.1944Z",
    fill: "#1D1D46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestart);
export default __webpack_public_path__ + "static/media/restart.ad21ac6ede205b08ea5366bffb3e845f.svg";
export { ForwardRef as ReactComponent };